<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" template=" <img src='assets/images/spinner.gif' />"></ngx-spinner>

<section class="welcome-page">
  <app-welcome-banner [bgImage]="leftBannerImgurl"></app-welcome-banner>
  <div class="welcome-content">
    <div class="welcome-form-area">
      <h2 class="welcome-title">Reset Password ?</h2>
      <p class="notify-text">Looks like you wanted to reset your password.
        Kindly enter the password you wanted for your account!</p>
      <form [formGroup]="ResetPasswordForm">
        <div class="form-group">
          <label class="label" for="password">New Password</label>
          <div class="form-control" style="display: flex; align-items: center; position: relative; width: 390px;">
            <input style="width: 100%; padding-right: 30px; outline: none; border: none;" [ngClass]="{
              'is-invalid':
                ResetPasswordForm.get('password')?.errors &&
                ResetPasswordForm.get('password')?.touched
            }" type="text" formControlName="password"   [type]="showOldPassword ? 'text' : 'password'" placeholder="Enter your new password " />
            <i class="fa-solid show-hide-password-icons new-password" [class.fa-eye-slash]="!showOldPassword"
            [class.fa-eye]="showOldPassword" (click)="showHideOldPassword($event)"></i>
          </div>
          <div *ngIf="
          ResetPasswordForm.get('password')?.touched || ResetPasswordForm.get('password')?.dirty"  >
            <mat-error class="invalid-feedback" *ngIf="
            ResetPasswordForm.get('password')?.hasError('required')
          ">
              * Password is required
            </mat-error>
          <mat-error class="invalid-feedback" *ngIf="
            ResetPasswordForm.get('password')?.hasError('minlength')
          ">
              * Password must be at least 8 characters long
            </mat-error>
            <mat-error class="invalid-feedback" *ngIf="
            ResetPasswordForm.get('password')?.hasError('maxlength')
          ">
              * Password must be less than 30 characters 
            </mat-error><br/>
            <mat-error class="invalid-feedback" *ngIf="
            ResetPasswordForm.get('password')?.hasError('pattern')
          ">
              * Password must contain at least one letter, one number, and one special character
            </mat-error>
          </div>
    
        </div>



        <div class="d-flex justify-content-front align-items-center">

          <button mat-flat-button color="accent" [disabled]="!ResetPasswordForm.valid" class="btn-accent btn-lg"
            (click)="onSubmit()">Submit</button>
          <button mat-button class="login-cancel-btn" routerLink="/login">Back</button>
        </div>
      </form>
    </div>

  </div>

</section>